<script>
	import { createEventDispatcher, getContext } from 'svelte'
	import { styles } from '../scripts/styles'
	import { slide } from 'svelte/transition'
	export let imagePath
	export let imageTitle
	export let imageText

	const globals = getContext('globals')

	const fsL = globals.fsL
	const fsN = globals.fsN

	const dispatch = new createEventDispatcher()

	const close_window = () => {
		dispatch('closewindow')
	}
</script>

<main transition:slide={{ duration: 500 }}>
	<div class="close_bar">
		<div class="close_icon" on:click={close_window} on:keydown={close_window} />
	</div>
	<div class="outer">
		<div class="title" use:styles={{ fsL }}>{imageTitle}</div>
		<div class="image"><img src={imagePath} alt="thumb" /></div>
		<div class="text">{imageText}</div>
	</div>
</main>

<style>
	main {
		background-color: black;
		height: fit-content;
		overflow: auto;
	}
	.close_bar {
		display: flex;
		justify-content: flex-end;
		width: 100%;
		height: fit-content;
		padding-right: 20px;
		margin-top: 20px;
	}

	.close_icon {
		width: 30px;
		height: 30px;
		background-image: url('/images/icon_close.png');
		background-size: cover;
		background-repeat: no-repeat;
		cursor: pointer;
	}
	.outer {
		display: flex;
		flex-direction: column;
		overflow: auto;
		align-items: center;
		color: white;
	}
	.title {
		font-size: var(--fsL);
		font-weight: bold;
		font-style: italic;
		margin-bottom: 20px;
	}
	.image {
		margin-bottom: 30px;
	}
	.text {
		font-size: var(--fsN);
		padding: 15px;
	}
</style>
